
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (ApiController.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
import { SubscriptionDetailsModel } from 'models/generated/Distribution.Api.Models.Csp.SubscriptionDetails';
import { MicrosoftSubscriptionModel } from 'models/generated/Distribution.Api.Models.MicrosoftSubscription';
import { SubscriptionModel } from 'models/generated/Distribution.Api.Models.Csp.Subscription';


const _distribution_SubscriptionControllerHelper = new Map<string, Object>();
_distribution_SubscriptionControllerHelper.set('GetSubscriptionDetailsFromCrayon', SubscriptionDetailsModel);
_distribution_SubscriptionControllerHelper.set('GetSubscriptionByProductPlanId', MicrosoftSubscriptionModel);
_distribution_SubscriptionControllerHelper.set('GetSubscriptionsByProductPlanIds', MicrosoftSubscriptionModel);
_distribution_SubscriptionControllerHelper.set('GetCrayonSubscriptions', SubscriptionModel);
_distribution_SubscriptionControllerHelper.set('UpdateSubscriptionInitialOrderData', MicrosoftSubscriptionModel);
_distribution_SubscriptionControllerHelper.set('AssignSubscriptionToExistingProductPlan', MicrosoftSubscriptionModel);


export const distribution_SubscriptionControllerHelper = _distribution_SubscriptionControllerHelper;

